import React, { useState } from 'react'
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react'
import { StoreProvider } from '../context'
import Navbar from './Navbar'

import header2 from "../assets/bank-assets/background.jpg"
import instagram from "../assets/logos/instagram.png";
import facebook from "../assets/logos/facebook.png";
import linkedIn from "../assets/logos/LinkedIn.png";
import greenNumber from "../assets/icons/numero_vert.png";
import condor from "../assets/logos/condor_logo.svg";
import BankLogo from "../assets/bank-assets/bank-footer-logo.svg";
import logo_footer_efaciliti from "../assets/logos/footerEfacilitiLogo.svg";
import { useTranslation } from "react-i18next";
import "../assets/css/ButtonDemo.css";
import ScrollToTopButton from './ScrollToTopButton'

function Footer_t() {
    var currentTime = new Date();
    var year = currentTime.getFullYear()
    const { t, i18n } = useTranslation();

    const socialLinks = [
        {
            title: "Condor",
            logo: condor,
            link: "https://www.condor.dz/"
        },
        {
            title: "Instagram",
            logo: instagram,
            link: "https://www.instagram.com/condor_electromenager"
        },
        {
            title: "Facebook",
            logo: facebook,
            link: "https://fr-fr.facebook.com/Condor.Electromenager"
        },
        {
            title: "LinkedIn",
            logo: linkedIn,
            link: "https://fr.linkedin.com/company/condor-algerie"
        },
    ]

    return (<footer
        className="px-3 py-8 text-2 text-gray-200  transition-colors duration-200"
        style={{
            backgroundImage: `url(${header2})`
        }}>
        <div className="flex flex-col">
            <div className="md:hidden mt-7 mx-auto w-11 h-px rounded-full">
            </div>
            <div className="mt-4 md:mt-0 flex flex-col md:flex-row">
                <nav
                    className="flex-1 flex flex-col items-center justify-center md:items-end md:border-r border-gray-100 md:pr-5">
                    <a aria-current="page" href="/eligibility" className="transition hover:text-yellow-500 dark:hover:text-white">
                        {t('home.Criteria')}
                    </a>
                    <a aria-current="page" href="/dossier" className="transition hover:text-yellow-500 dark:hover:text-white">
                        {t('home.fileProvided')}
                    </a>
                    <a aria-current="page" href="/contact" className="transition hover:text-yellow-500 dark:hover:text-white">
                        {t('home.contactUs')}
                    </a>
                </nav>
                <div className="md:hidden mt-4 mx-auto w-11 h-px rounded-full">
                </div>
                <div className="mt-4 md:mt-0 flex-1 flex items-center justify-center md:border-r border-gray-100">

                    <div
                        className="flex flex-col items-center justify-center w-2/3 h-2/3 mx-8 rounded-full sm:w-2/3 sm:h-2/3 dark:bg-violet-400 dark:text-gray-900">
                        <div
                            className="flex items-center content-center justify-center w-full rounded-full sm:w-full sm:h-1/3 dark:bg-violet-400 dark:text-gray-900"
                        >
                            <a className="w-1/2 p-2" rel="noopener noreferrer" href="https://e-faciliti.dz/"
                                target="_blank" title="E-Faciliti">
                                <img className="w-full" src={logo_footer_efaciliti} />
                            </a>
                            <a className="w-1/2 p-2" rel="noopener noreferrer" href="https://www.bea.dz/"
                                target="_blank" title="BEA">
                                <img className="w-full" src={BankLogo} />
                            </a>
                        </div>
                        <br />
                        <a rel="noopener noreferrer" href="https://e-faciliti.dz/"
                            target="_blank" title="E-Faciliti"
                            className="flex items-center justify-center mt-2 "
                        >
                            <img className="w-1/2" src={greenNumber} />
                        </a>
                    </div>
                </div>
                <div className="md:hidden mt-4 mx-auto w-11 h-px rounded-full ">
                </div>
                <div className="mt-7 md:mt-0 flex-1 flex flex-col items-center justify-center md:items-start md:pl-5">
                    <span className="">
                        © {year}
                    </span>
                    <span className="mt-7 md:mt-1">
                        <a className="underline mx-2 hover:text-yellow-500 transition" href="https://www.condor.dz/" target="_blank"
                            title="Condor">
                            SPA Condor Electronics
                        </a>
                        {i18n.language === "fr" ? "tous droits réservés" : "جميع الحقوق محفوظة"}
                    </span>

                    <div className='flex items-center justify-center md:mt-2'>
                        {
                            socialLinks.map((platform, index) =>
                                <a key={index} rel="noopener noreferrer" href={platform.link} target="_blank" title={platform.title}
                                    className="flex items-center justify-center m-2 rounded-full w-4 h-4 md:w-8 md:h-8 dark:bg-violet-400 dark:text-gray-900">
                                    <img className="" src={platform.logo} />
                                </a>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    </footer>);
}


function Content({ children }) {
    const [visibleRight, setVisibleRight] = useState(false);
    const { isLoading, error } = useAuth0()
    const { t, i18n } = useTranslation();
    if (isLoading) return null;
    if (error) return 'error...';

    return (
        <div className={i18n.language === 'fr' ? 'font-cairo' : 'font-cairo'}>
            <Navbar />
            <main className="place-self-center">
                {children}
                <ScrollToTopButton />
            </main>
            <Footer_t />
        </div>
    );
}

export default function AppProvider(props) {

    return (
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH_DOMAIN}
            clientId={process.env.REACT_APP_CLIENT_ID}
            redirectUri={window.location.origin}
        >
            <StoreProvider>
                <Content {...props} />
            </StoreProvider>
        </Auth0Provider>
    );
}